// AMO CRM mapping кассового модуля — единый источник дефолтов id кастом-полей
// сделки (правило 1 «Single source of truth», образец — flex/amo.ts карточки
// amo-flex-defaults-shared). Потребители:
//   - admin-форма настроек (apps/admin .../CashboxSettings.tsx, onSave) —
//     фолбэк при пустом/невалидном вводе;
//   - schema.prisma (CashboxSettings.amoFieldPaymentMethod/amoFieldTrackAmount,
//     @default) — сверяется contract-тестом
//     apps/api/src/services/cashboxAmo.defaults.contract.test.ts (тест живёт в
//     api, а не здесь: turbo кэширует test по файлам своего пакета, и тест в
//     shared не перезапустился бы при правке schema.prisma).
// Рантайм-источник значений — строка CashboxSettings в БД (правило 2: id полей
// AMO не зашиваются в сервисы); эти дефолты — только seed схемы и фолбэк формы.
export const DEFAULT_CASHBOX_AMO_FIELDS = Object.freeze({
    paymentMethod: 1308317,
    trackAmount: 1337443,
});
//# sourceMappingURL=amo.js.map